import { Link } from 'react-router-dom';
import { images } from '../../assets';
import { GridBackground } from '../GridBackground';

const ExerciseGrid = ({ shouldOpenAccordions }) => {
  const allGrupos = [
    { nombre: 'Pecho', slug: 'pecho', img: images.pecho, count: '9 ejercicios' },
    { nombre: 'Espalda', slug: 'espalda', img: images.espalda, count: '9 ejercicios' },
    { nombre: 'Hombros', slug: 'hombros', img: images.hombros, count: '6 ejercicios' },
    { nombre: 'Bíceps', slug: 'biceps', img: images.biceps, count: '6 ejercicios' },
    { nombre: 'Tríceps', slug: 'triceps', img: images.triceps, count: '7 ejercicios' },
    { nombre: 'Piernas', slug: 'piernas', img: images.piernas, count: '18 ejercicios' },
    { nombre: 'Abdominales', slug: 'abdominales', img: images.abdominales, count: '5 ejercicios' },
  ];

  // Duplicar elementos para un loop infinito continuo y fluido
  const marqueeItems = [...allGrupos, ...allGrupos];

  return (
    <section id="ejercicios" className="relative py-12 sm:py-20 px-4 md:px-8 bg-gray-900 overflow-hidden">
      <GridBackground />
      <div className="relative z-10 max-w-7xl mx-auto">
        <h2 className="anton-font text-3xl sm:text-5xl md:text-6xl text-center text-white uppercase leading-tight mb-3 sm:mb-4 tracking-normal">
          GUÍA DE EJERCICIOS DE GYM
        </h2>
        <p className="text-sm sm:text-base md:text-lg text-gray-400 mb-8 sm:mb-12 text-center max-w-3xl mx-auto">
          Guía de ejercicios de gym para principiantes: referencias visuales por grupo muscular para ganar masa muscular y potenciar tu entrenamiento.
        </p>

        {/* Franja con movimiento animado continuo (Infinite Marquee) */}
        <div className="relative w-full overflow-hidden py-2 sm:py-4">
          {/* Fades laterales para difuminar bordes en la franja */}
          <div className="absolute left-0 top-0 bottom-0 w-12 sm:w-28 bg-gradient-to-r from-gray-900 via-gray-900/80 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-12 sm:w-28 bg-gradient-to-l from-gray-900 via-gray-900/80 to-transparent z-10 pointer-events-none" />

          <div className="animate-marquee flex items-center">
            {marqueeItems.map((grupo, idx) => (
              <Link
                key={`${grupo.slug}-${idx}`}
                to={`/${grupo.slug}`}
                state={shouldOpenAccordions ? { openAccordion: true } : undefined}
                className="group flex items-center gap-3 sm:gap-4 mx-2 sm:mx-3 p-2.5 sm:p-3 pr-4 sm:pr-6 rounded-xl sm:rounded-2xl bg-black/80 border border-neutral-800 hover:border-neutral-600 transition-all duration-300 hover:bg-neutral-900 shadow-xl select-none whitespace-nowrap min-w-[220px] sm:min-w-[280px]"
              >
                {/* Imagen Thumbnail con efecto grayscale a color en hover */}
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg sm:rounded-xl overflow-hidden flex-shrink-0 relative bg-neutral-950 border border-neutral-800">
                  <img
                    src={grupo.img}
                    alt={grupo.nombre}
                    className="w-full h-full object-cover filter grayscale contrast-125 group-hover:grayscale-0 group-hover:scale-110 transition-all duration-500"
                    loading="lazy"
                  />
                </div>

                {/* Textos informativos */}
                <div className="flex flex-col">
                  <div className="flex items-center gap-1.5 sm:gap-2">
                    <span className="text-neutral-500 font-mono text-[10px] sm:text-[11px]">
                      0{(idx % allGrupos.length) + 1}
                    </span>
                    <span className="text-[10px] sm:text-[11px] text-neutral-400 uppercase tracking-wider font-medium">
                      {grupo.count}
                    </span>
                  </div>
                  <span className="bebas-font text-xl sm:text-3xl tracking-wider text-white group-hover:text-blue-400 transition-colors leading-tight mt-0.5">
                    {grupo.nombre.toUpperCase()}
                  </span>
                </div>

                {/* Flecha minimalista */}
                <div className="ml-auto pl-1 sm:pl-2 text-neutral-600 group-hover:text-white group-hover:translate-x-1 transition-all duration-300">
                  <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Botón tentador y minimalista en negro */}
        <div className="mt-8 sm:mt-12 flex flex-col items-center justify-center text-center">
          <Link
            to="/pecho"
            state={shouldOpenAccordions ? { openAccordion: true } : undefined}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-black hover:bg-neutral-900 text-white px-6 py-3.5 sm:px-9 sm:py-4 rounded-xl border border-neutral-700 hover:border-neutral-500 shadow-2xl transition-all duration-300 hover:scale-[1.02] font-semibold text-xs sm:text-base uppercase tracking-wider group"
          >
            <span>Explorar Guía Completa de Ejercicios</span>
            <svg
              className="w-4 h-4 sm:w-5 sm:h-5 text-neutral-400 group-hover:text-white group-hover:translate-x-1.5 transition-all duration-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
          <span className="text-[11px] sm:text-xs text-neutral-500 mt-2.5 sm:mt-3.5 tracking-wide">
            Técnica correcta, series, repeticiones y videos demostrativos
          </span>
        </div>
      </div>
    </section>
  );
};

export default ExerciseGrid;
